import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import { ISite } from "../../../../util/varibles/interface";
import AddExternalSite from "../_components/AddExternalSite";
import stylesContainer from "../style.module.scss";
import Filter from "./Filter";

interface IProps {
    onSearch(value: string): void
    sites: ISite[]
    siteFilter: number
}

export default function HeaderTab(props: IProps) {
    const { onSearch, sites, siteFilter } = props;

    return <div className={stylesContainer['tab-header']}>
        <Input
            className="w-full max-w-[320px] h-[36px] rounded-[36px]"
            placeholder="Search for site by name"
            allowClear
            onChange={({ target: { value } }: any) => onSearch(value)}
            suffix={<SearchOutlined className='text-comment' />}
        />
        <Filter sites={sites} siteFilter={siteFilter} />
        <AddExternalSite />
    </div>;
}